import React from "react";
import { useSection } from "../../i18n/useSection";

// Reflect the real validator. The mock's additional categories are not required by this flow.
export default function PasswordRule({ password, id }) {
  const t = useSection("mmtAuth");
  const valid = password.length >= 8;
  return (
    <ul className="mmt-password-rules" id={id}>
      <li className={valid ? "ok" : ""}>
        <svg viewBox="0 0 16 16" aria-hidden="true">
          {valid ? (
            <>
              <circle cx="8" cy="8" r="7" fill="currentColor" />
              <path
                d="M4.8 8.2l2.1 2.1 4.3-4.5"
                fill="none"
                stroke="#fff"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </>
          ) : (
            <circle
              cx="8"
              cy="8"
              r="6"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
            />
          )}
        </svg>
        {t.password_length}
      </li>
    </ul>
  );
}
